"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = void 0;
var constants_1 = require("../data/constants");
function copyToClipboard() {
    var elements = document.querySelectorAll("[".concat(constants_1.DATA_COPY, "]"));
    if (!(elements.length > 0))
        return;
    elements.forEach(function (element) {
        element.addEventListener('click', function () {
            var target = document.querySelector("[".concat(constants_1.DATA_COPY_TEXT, "]"));
            var targetText = target.innerText;
            navigator.clipboard.writeText(targetText);
        });
    });
}
exports.copyToClipboard = copyToClipboard;
